import React from 'react';
import { enquireScreen } from 'enquire-js';
import { Outlet } from 'react-router-dom';
import LayoutHeader from './components/Header';
import LayoutFooter from './components/Footer';
import { Nav00DataSource, Footer10DataSource } from './data.source';
import { debounce } from 'lodash';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

export default class LayoutIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirstScreen: true,
      isMobile,
      isHidden: true
    };
    this.handleScroll = debounce(this.handleScroll, 100);
  }

  // 定义回到顶部的方法
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
  }

  handleScroll = () => {
    const shouldHide = window.pageYOffset <= 300;
    this.setState({ isHidden: shouldHide });
  };

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      // 解决从电脑端web切换到移动web头部不显示的问题
      const isMobile = b ? 'true' : 'false';
      localStorage.getItem('isMobile') !== isMobile ? location.reload() : '';
      localStorage.setItem('isMobile', b ? 'true' : 'false');
      this.setState({ isMobile: !!b });
    });

    // 监听滚动事件
    console.log('addEventListener');
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  onEnterChange = (mode) => {
    this.setState({
      isFirstScreen: mode === 'enter',
    });
  };

  render() {
    const children = [
      <LayoutHeader
        id="Nav0_0"
        key="Nav0_0"
        dataSource={Nav00DataSource}
        isFirstScreen={this.state.isFirstScreen}
        isMobile={this.state.isMobile}
      />,
      <Outlet
        key="router"
        context={{
          onEnterChange: this.onEnterChange,
          isFirstScreen: this.state.isFirstScreen,
          isMobile: this.state.isMobile,
        }}
        // onEnterChange={this.onEnterChange}
      />,
      <LayoutFooter
        id="Footer1_0"
        key="Footer1_0"
        dataSource={Footer10DataSource}
        isMobile={this.state.isMobile}
      />,
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {children}
        {/* 添加onClick事件处理 */}
        <img
          src={require('@/assets/image/back-up.png')}
          alt="回到顶部"
          className={this.state.isHidden ? 'back-up hidden' : 'back-up'}
          onClick={this.scrollToTop} // 绑定点击事件
        />
      </div>
    );
  }
}
